import { __awaiter } from "tslib";
import axios from 'axios';
import { useQuery, } from '@tanstack/react-query';
import { merge } from '@fluentui/react';
import { SINGLETON_DATA_STALE_TIME_MSEC } from '../../constants';
import { useAnalytics } from '@msrceng/analytics';
import { useOApiReady } from './util/useOApiReady';
const defaultOptions = {
    enabled: true,
    requireId: true,
    isAuthRequired: true,
    isVerificationRequired: true,
    useQueryOptions: {
        keepPreviousData: true,
    },
};
/**
 * Premade Odata API for querying (get) SINGLETON operations
 *
 * @example
 * // (requesting an individual vuln report)
 * 'api.microsoft.com/vulnerabilityReport/VULN-1234'
 */
export const useODataReadSingleApi = (
/** The url path (relative) of this entity on top of the apiRoot */
endpointName, 
/** The ID of your entity to fetch ('/someEntity/id') */
id, options) => {
    const { appInsights } = useAnalytics();
    const { enabled: isEnabledInOptions, isAuthRequired, isVerificationRequired, requireId, debug, useQueryOptions, } = merge({}, defaultOptions, options);
    /** Did our gates for verification/auth/etc pass? */
    const isReady = useOApiReady({ isAuthRequired, isVerificationRequired });
    const isIdReady = !requireId || !!id;
    /** Did *all* pre-request checks pass? */
    const enabled = isEnabledInOptions && isIdReady && isReady;
    if (debug) {
        console.info({
            endpointName,
            enabled,
            isIdReady,
            isAuthRequired,
        });
    }
    const single = useQuery(Object.assign(Object.assign({}, (useQueryOptions || {})), { queryKey: [endpointName, id], queryFn: () => getEntitySingle({
            id,
            endpointName,
            debug,
        }), onError: error => appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackException({
            exception: error,
        }), retry: false, cacheTime: SINGLETON_DATA_STALE_TIME_MSEC, staleTime: SINGLETON_DATA_STALE_TIME_MSEC, enabled }));
    return single;
};
const getEntitySingle = ({ endpointName, id, debug, }) => __awaiter(void 0, void 0, void 0, function* () {
    // if (!id || id.length < 1) {
    //   return Promise.reject('Invalid id in Singleton query request');
    // }
    //what follows is a hack to flatten various singleton response types
    //to the correct data type.
    //Singleton responses can be:
    // - {...content, ...odataStuff }         // return response
    // - {...odataStuff, data: [ content ] }  // return response.data[0]
    // - {...odataStuff, data:content }       // return response.data
    const endpointWithId = `${endpointName}${id ? `/${id}` : ''}`;
    return axios
        .get(endpointWithId)
        .then(res => {
        var _a;
        if (debug) {
            console.log(`[${endpointWithId}] response recieved:`);
            console.log(res);
        }
        const data = res.data;
        return ((_a = data === null || data === void 0 ? void 0 : data.value) === null || _a === void 0 ? void 0 : _a[0]) || (data === null || data === void 0 ? void 0 : data.value) || data;
    });
});
